import { observable, toJS } from 'mobx';
import API from 'api';

export default class PrescriberPracticeContact {
	@observable id: number;
	@observable prescriberPracticeID: number;
	@observable contactName: string;
	@observable contactSurname: string;
	@observable contactMobile: string;
	@observable contactPhone: string;
	@observable contactFAX: string;
	@observable contactEmail: string;
	@observable created: string;
	@observable modified: string;
	@observable disabled: boolean = false;
	@observable isDeleted: boolean = false;

	constructor(data: PrescriberPracticeContact) {
		this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	update = async (withData = null) => {
		let data = withData || toJS(this);
		console.log('saving PPC data:', data);
		if (data.isDeleted) {
			// Delete
			await API.delete(`/PrescriberPracticeContacts/${this.id}`);
		} else if (data.id) {
			// Update
			await API.patch(`/PrescriberPracticeContacts/${this.id}`, data);
		} else {
			// New
			await API.post(`/PrescriberPracticeContacts`, data);
		}
	};
}



// WEBPACK FOOTER //
// ./src/stores/PrescriberPracticeContact.js